module.exports = __webpack_public_path__ + "static/media/THIRD-PARTY-LOGISTICS.7432fbf4.jpg";